import loc from "i18next";
import {
    LocalDateStringOption,
    AllowedShareActionFlags,
    type AllowedShareActionFlagsEnum,
} from "data/types";
import {
    getClientLinkHtml,
    getBrowserLinkHtml,
    inPointAction,
} from "components/ItemUriLink";
import { userLanguage } from "data/storeHelper";

export const getShareDate = (expires: string) =>
    expires
        ? loc.t(`share:action.date`, {
              expires: new Date(expires).toLocaleDateString(
                  userLanguage(),
                  LocalDateStringOption.Date
              ),
          })
        : "";

export const getBytes = (bytes: number): string => {
    const i = Math.floor(Math.log(bytes) / Math.log(1024));
    return (
        (!bytes && "0 Bytes") ||
        (bytes / Math.pow(1024, i)).toFixed(2) +
            " " +
            ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][i]
    );
};

export const getMailLink = (label, link, multiple = false) =>
    loc.t(`share:mail.link.template${multiple ? "_multi" : ""}`, {
        label,
        link,
    });
export const getMailSyncLink = (
    name: string,
    itemUri: string,
    isDoc: boolean,
    allowedShareActionFlags: AllowedShareActionFlagsEnum,
    multiple?: boolean
) =>
    (allowedShareActionFlags & AllowedShareActionFlags.Sync) > 0
        ? getMailLink(
              loc.t("share:mail.link.sync"),
              getClientLinkHtml(
                  name,
                  itemUri,
                  isDoc ? inPointAction.preview : inPointAction.browse
              ),
              multiple
          )
        : "";
export const getMailWebLink = (
    name: string,
    itemUri: string,
    isDoc: boolean,
    allowedShareActionFlags: AllowedShareActionFlagsEnum,
    multiple?: boolean
) =>
    (allowedShareActionFlags & AllowedShareActionFlags.Web) > 0
        ? getMailLink(
              loc.t("share:mail.link.web"),
              getBrowserLinkHtml(name, itemUri, isDoc),
              multiple
          )
        : "";

export const getMailMessage = (message: string) =>
    message
        ? loc.t("share:mail.message", {
              message,
          })
        : "";

export const getItemKey = (isDoc: boolean, isMixed: boolean = false) =>
    isMixed ? "mixed" : isDoc ? "document" : "folder";
export const getActionKey = (isEdit: boolean) => (isEdit ? "update" : "create");

export /**
 * Maps EnumValues to their designated icons
 *
 * @param { id: string } { enum value identifier }
 * @returns {string} fontawesome 4.7 icon identifier
 */
const getEnumIcon = (id: string): ?string => {
    switch (id) {
        // ShareAccessControlListType
        case "view":
            return "eye";
        case "edit":
            return "pencil";
        case "delete":
            return "pencil-square-o";
        // ShareType
        /* istanbul ignore next */
        case "anonym":
            return "globe";
        case "link":
            return "link";
        case "share":
            return "share-alt";
        case "attachment":
            return "envelope-o";
        case "pdf":
            return "file-pdf-o";
        /* istanbul ignore next */
        default:
            return undefined;
    }
};
